module.exports = __webpack_public_path__ + "6b98c3e4f769ecc885077c5c4575ac2f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/advanced_micro_devices_2023_chart.png
// module id = 1626
// module chunks = 0